<div #mainDiv_ll_model_collateral_edit_model>
  <div *ngIf="bundle.showDisplay"
       [style.top.px]="bundle.panelY"
       [style.left.px]="bundle.panelX"
       style="position: absolute;">
    <jqxPanel [autoUpdate]="true"
              [width]="bundle.panelW"
              [height]="bundle.panelH"
              style="background-color: transparent; border: none; border-bottom: 2px solid rgb(160, 158, 158);">
      <div class="form-container">


        <div class="form-row">
          <label class="form-label">Display Ineligible Payer Type:</label>

          <select [ngModel]="bbcIneligiblePayerDisplayType"
                  (ngModelChange)="onChanged('BBC_INELIGIBLEPAYERDISPLAYTYPE', $event)"
                  class="form-input form-select">
            <option value="" disabled *ngIf="!bbcIneligiblePayerDisplayType">
              Select ...
            </option>
            <option *ngFor="let opt of ineligiblePayerDisplayTypeOptions"
                    [value]="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>

        <div class="form-row">
          <label class="form-label">Adjustment_01 Field on BBC:</label>
          <div class="true-up-container"
               style="flex: 1; display: flex; align-items: center; gap: 24px; white-space: nowrap;">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeadjustment01YesNo"
                       [value]="'Yes'"
                       [checked]="bbcIncludeadjustment01YesNo === 'Yes'"
                       (change)="onChanged('BBC_INCLUDE_ADJUSTMENT_01YESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeadjustment01YesNo"
                       [value]="'No'"
                       [checked]="bbcIncludeadjustment01YesNo === 'No'"
                       (change)="onChanged('BBC_INCLUDE_ADJUSTMENT_01YESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Adjustment_02 Field on BBC:</label>
          <div class="true-up-container"
               style="flex: 1; display: flex; align-items: center; gap: 24px; white-space: nowrap;">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeadjustment02YesNo"
                       [value]="'Yes'"
                       [checked]="bbcIncludeadjustment02YesNo === 'Yes'"
                       (change)="onChanged('BBC_INCLUDE_ADJUSTMENT_02YESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeadjustment02YesNo"
                       [value]="'No'"
                       [checked]="bbcIncludeadjustment02YesNo === 'No'"
                       (change)="onChanged('BBC_INCLUDE_ADJUSTMENT_02YESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Adjustment_03 Field on BBC:</label>
          <div class="true-up-container"
               style="flex: 1; display: flex; align-items: center; gap: 24px; white-space: nowrap;">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeadjustment03YesNo"
                       [value]="'Yes'"
                       [checked]="bbcIncludeadjustment03YesNo === 'Yes'"
                       (change)="onChanged('BBC_INCLUDE_ADJUSTMENT_03YESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeadjustment03YesNo"
                       [value]="'No'"
                       [checked]="bbcIncludeadjustment03YesNo === 'No'"
                       (change)="onChanged('BBC_INCLUDE_ADJUSTMENT_03YESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Adjustment_04 Field on BBC:</label>
          <div class="true-up-container"
               style="flex: 1; display: flex; align-items: center; gap: 24px; white-space: nowrap;">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeadjustment04YesNo"
                       [value]="'Yes'"
                       [checked]="bbcIncludeadjustment04YesNo === 'Yes'"
                       (change)="onChanged('BBC_INCLUDE_ADJUSTMENT_04YESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeadjustment04YesNo"
                       [value]="'No'"
                       [checked]="bbcIncludeadjustment04YesNo === 'No'"
                       (change)="onChanged('BBC_INCLUDE_ADJUSTMENT_04YESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Adjustment_05 Field on BBC:</label>
          <div class="true-up-container"
               style="flex: 1; display: flex; align-items: center; gap: 24px; white-space: nowrap;">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeadjustment05YesNo"
                       [value]="'Yes'"
                       [checked]="bbcIncludeadjustment05YesNo === 'Yes'"
                       (change)="onChanged('BBC_INCLUDE_ADJUSTMENT_05YESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeadjustment05YesNo"
                       [value]="'No'"
                       [checked]="bbcIncludeadjustment05YesNo === 'No'"
                       (change)="onChanged('BBC_INCLUDE_ADJUSTMENT_05YESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Include Last as Begining Balance on BBC:</label>
          <div class="true-up-container"
               style="flex: 1; display: flex; align-items: center; gap: 24px; white-space: nowrap;">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcAutoBeginLoanBalanceYesNo"
                       [value]="'Yes'"
                       [checked]="bbcAutoBeginLoanBalanceYesNo === 'Yes'"
                       (change)="onChanged('BBC_AUTOBEGINLOANBALANCEYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcAutoBeginLoanBalanceYesNo"
                       [value]="'No'"
                       [checked]="bbcAutoBeginLoanBalanceYesNo === 'No'"
                       (change)="onChanged('BBC_AUTOBEGINLOANBALANCEYESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Borrower Signature Required:</label>
          <div class="true-up-container">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0; padding-right: 30px ">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcClientSigRequiredYesNo"
                       [value]="'Yes'"
                       [checked]="bbcClientSigRequiredYesNo === 'Yes'"
                       (change)="onChanged('BBC_CLIENTSIG_REQUIREDYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcClientSigRequiredYesNo"
                       [value]="'No'"
                       [checked]="bbcClientSigRequiredYesNo === 'No'"
                       (change)="onChanged('BBC_CLIENTSIG_REQUIREDYESNO', 'No')" />
                No
              </label>
            </div>
          </div>
          <div *ngIf="bbcClientSigRequiredYesNo === 'Yes'"
               style="display: flex; align-items: center; gap: 12px; flex-shrink: 0; padding-right: 0px ">
            <label class="form-label" style="width: 175px; text-align: left; padding-right: 0px;">
              Include Sig. on PDF:
            </label>
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcClientSigOnPDFYesNo"
                       [value]="'Yes'"
                       [checked]="bbcClientSigOnPDFYesNo === 'Yes'"
                       (change)="onChanged('BBC_CLIENTSIG_ONPDFYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcClientSigOnPDFYesNo"
                       [value]="'No'"
                       [checked]="bbcClientSigOnPDFYesNo === 'No'"
                       (change)="onChanged('BBC_CLIENTSIG_ONPDFYESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <div class="form-row" *ngIf="bbcClientSigRequiredYesNo === 'Yes'">
          <label class="form-label">On Borrower Signature - Email BBC:</label>
          <div class="true-up-container">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0; padding-right: 30px ">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcClientSigEmailYesNo"
                       [value]="'Yes'"
                       [checked]="bbcClientSigEmailYesNo === 'Yes'"
                       (change)="onChanged('BBC_CLIENTSIG_EMAILYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcClientSigEmailYesNo"
                       [value]="'No'"
                       [checked]="bbcClientSigEmailYesNo === 'No'"
                       (change)="onChanged('BBC_CLIENTSIG_EMAILYESNO', 'No')" />
                No
              </label>
            </div>
          </div>
          <div *ngIf="bbcClientSigEmailYesNo === 'Yes'"
               style="display: flex; align-items: center; gap: 12px; flex-shrink: 0; padding-right: 0px ">
            <label class="form-label" style="width: 175px; text-align: left; padding-right: 0px;">
              Include Attachments:
            </label>
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcClientSigEmailAttachmentYesNo"
                       [value]="'Yes'"
                       [checked]="bbcClientSigEmailAttachmentYesNo === 'Yes'"
                       (change)="onChanged('BBC_CLIENTSIG_EMAILATTACHYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcClientSigEmailAttachmentYesNo"
                       [value]="'No'"
                       [checked]="bbcClientSigEmailAttachmentYesNo === 'No'"
                       (change)="onChanged('BBC_CLIENTSIG_EMAILATTACHYESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <!-- Updated: Email Signed BBC To (display + modal) -->
        <div class="form-row" *ngIf="bbcClientSigRequiredYesNo === 'Yes' && bbcClientSigEmailYesNo === 'Yes'">
          <label class="form-label">Email Signed BBC To:</label>
          <div style="display: flex; align-items: flex-start; gap: 16px; flex: 1; flex-wrap: wrap;">
            <div class="form-input display-only"
                 style="flex: 1; min-width: 300px; max-width: 600px; min-height: 50px; height: auto;
                        padding: 8px 12px; white-space: pre-wrap; word-wrap: break-word;
                        overflow-wrap: break-word; line-height: 1.45; font-size: 13px;
                        background-color: #f9f9f9; border: 1px solid #ccc; border-radius: 4px;">
              {{ recipientsDisplay('BBC_RECEIVESIGNED_PRIMARY') }}
            </div>
            <span class="wordBtn_12"
                  (click)="openRecipientsModal('BBC_RECEIVESIGNED_PRIMARY', 'Select Recipients for Signed BBC')"
                  style="cursor: pointer; white-space: nowrap; padding-top: 8px; align-self: flex-start;">
              Change
            </span>
          </div>
        </div>

        <div class="form-row" *ngIf="bbcClientSigRequiredYesNo === 'Yes' && bbcClientSigEmailYesNo === 'Yes'">
          <label class="form-label">Email Signed BBC Copied:</label>
          <div style="display: flex; align-items: flex-start; gap: 16px; flex: 1; flex-wrap: wrap;">
            <div class="form-input display-only"
                 style="flex: 1; min-width: 300px; max-width: 600px; min-height: 50px; height: auto;
                padding: 8px 12px; white-space: pre-wrap; word-wrap: break-word;
                overflow-wrap: break-word; line-height: 1.45; font-size: 13px;
                background-color: #f9f9f9; border: 1px solid #ccc; border-radius: 4px;">
              {{ recipientsDisplay('BBC_RECEIVESIGNED_COPIED') }}
            </div>
            <span class="wordBtn_12"
                  (click)="openRecipientsModal('BBC_RECEIVESIGNED_COPIED', 'Select CC Recipients for Signed BBC')"
                  style="cursor: pointer; white-space: nowrap; padding-top: 8px; align-self: flex-start;">
              Change
            </span>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Approval Signature Required:</label>
          <div class="true-up-container">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0; padding-right: 30px ">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcApproveSigRequiredYesNo"
                       [value]="'Yes'"
                       [checked]="bbcApproveSigRequiredYesNo === 'Yes'"
                       (change)="onChanged('BBC_APPROVESIG_REQUIREDYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcApproveSigRequiredYesNo"
                       [value]="'No'"
                       [checked]="bbcApproveSigRequiredYesNo === 'No'"
                       (change)="onChanged('BBC_APPROVESIG_REQUIREDYESNO', 'No')" />
                No
              </label>
            </div>
          </div>

          <div *ngIf="bbcApproveSigRequiredYesNo === 'Yes'"
               style="display: flex; align-items: center; gap: 12px; flex-shrink: 0; padding-right: 0px ">
            <label class="form-label" style="width: 175px; text-align: left; padding-right: 0px;">
              Include Sig. on PDF:
            </label>
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcApproveSigOnPDFYesNo"
                       [value]="'Yes'"
                       [checked]="bbcApproveSigOnPDFYesNo === 'Yes'"
                       (change)="onChanged('BBC_APPROVESIG_ONPDFYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcApproveSigOnPDFYesNo"
                       [value]="'No'"
                       [checked]="bbcApproveSigOnPDFYesNo === 'No'"
                       (change)="onChanged('BBC_APPROVESIG_ONPDFYESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <div class="form-row" *ngIf="bbcApproveSigRequiredYesNo === 'Yes'">
          <label class="form-label">On Approve Signature - Email BBC:</label>

          <div class="true-up-container">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0; padding-right: 30px ">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcApproveSigEmailYesNo"
                       [value]="'Yes'"
                       [checked]="bbcApproveSigEmailYesNo === 'Yes'"
                       (change)="onChanged('BBC_APPROVESIG_EMAILYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcApproveSigEmailYesNo"
                       [value]="'No'"
                       [checked]="bbcApproveSigEmailYesNo === 'No'"
                       (change)="onChanged('BBC_APPROVESIG_EMAILYESNO', 'No')" />
                No
              </label>
            </div>
          </div>

          <div *ngIf="bbcApproveSigEmailYesNo === 'Yes'"
               style="display: flex; align-items: center; gap: 12px; flex-shrink: 0; padding-right: 0px ">
            <label class="form-label" style="width: 175px; text-align: left; padding-right: 0px;">
              Include Attachments:
            </label>
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcApproveSigEmailAttachmentYesNo"
                       [value]="'Yes'"
                       [checked]="bbcApproveSigEmailAttachmentYesNo === 'Yes'"
                       (change)="onChanged('BBC_APPROVESIG_EMAILATTACHYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcApproveSigEmailAttachmentYesNo"
                       [value]="'No'"
                       [checked]="bbcApproveSigEmailAttachmentYesNo === 'No'"
                       (change)="onChanged('BBC_APPROVESIG_EMAILATTACHYESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <div class="form-row" *ngIf="bbcApproveSigRequiredYesNo === 'Yes' && bbcApproveSigEmailYesNo === 'Yes'">
          <label class="form-label">Email Approved BBC To:</label>

          <div style="display: flex; align-items: flex-start; gap: 16px; flex: 1; flex-wrap: wrap;">
            <div class="form-input display-only"
                 style="flex: 1; min-width: 300px; max-width: 600px; min-height: 50px; height: auto;
              padding: 8px 12px; white-space: pre-wrap; word-wrap: break-word;
              overflow-wrap: break-word; line-height: 1.45; font-size: 13px;
              background-color: #f9f9f9; border: 1px solid #ccc; border-radius: 4px;">
              {{ recipientsDisplay('BBC_RECEIVEAPPROVED_PRIMARY') }}
            </div>
            <span class="wordBtn_12"
                  (click)="openRecipientsModal('BBC_RECEIVEAPPROVED_PRIMARY', 'Select Recipients for Approved BBC')"
                  style="cursor: pointer; white-space: nowrap; padding-top: 8px; align-self: flex-start;">
              Change
            </span>
          </div>
        </div>

        <div class="form-row" *ngIf="bbcApproveSigRequiredYesNo === 'Yes' && bbcApproveSigEmailYesNo === 'Yes'">
          <label class="form-label">Email Approved BBC Copied:</label>
          <div style="display: flex; align-items: flex-start; gap: 16px; flex: 1; flex-wrap: wrap;">
            <div class="form-input display-only"
                 style="flex: 1; min-width: 300px; max-width: 600px; min-height: 50px; height: auto;
               padding: 8px 12px; white-space: pre-wrap; word-wrap: break-word;
               overflow-wrap: break-word; line-height: 1.45; font-size: 13px;
               background-color: #f9f9f9; border: 1px solid #ccc; border-radius: 4px;">
              {{ recipientsDisplay('BBC_RECEIVEAPPROVED_COPIED') }}
            </div>
            <span class="wordBtn_12"
                  (click)="openRecipientsModal('BBC_RECEIVEAPPROVED_COPIED', 'Select CC Recipients for Approved BBC')"
                  style="cursor: pointer; white-space: nowrap; padding-top: 8px; align-self: flex-start;">
              Change
            </span>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Email BBC Due Reminders:</label>
          <div class="true-up-container">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0; padding-right: 30px ">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcDueReminderYesNo"
                       [value]="'Yes'"
                       [checked]="bbcDueReminderYesNo === 'Yes'"
                       (change)="onChanged('BBC_DUEREMINDERYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcDueReminderYesNo"
                       [value]="'No'"
                       [checked]="bbcDueReminderYesNo === 'No'"
                       (change)="onChanged('BBC_DUEREMINDERYESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <div class="form-row" *ngIf="bbcDueReminderYesNo === 'Yes'">
          <label class="form-label">Email BBC Reminders To:</label>

          <div style="display: flex; align-items: flex-start; gap: 16px; flex: 1; flex-wrap: wrap;">
            <div class="form-input display-only"
                 style="flex: 1; min-width: 300px; max-width: 600px; min-height: 50px; height: auto;
      padding: 8px 12px; white-space: pre-wrap; word-wrap: break-word;
      overflow-wrap: break-word; line-height: 1.45; font-size: 13px;
      background-color: #f9f9f9; border: 1px solid #ccc; border-radius: 4px;">
              {{ recipientsDisplay('BBC_DUEREMINDER_PRIMARY') }}
            </div>
            <span class="wordBtn_12"
                  (click)="openRecipientsModal('BBC_DUEREMINDER_PRIMARY', 'Select Recipients for BBC Reminders')"
                  style="cursor: pointer; white-space: nowrap; padding-top: 8px; align-self: flex-start;">
              Change
            </span>
          </div>
        </div>

        <!-- NEW: Dropdown for Email BBC Reminders To (System Email Routine) -->
        <div class="form-row" *ngIf="bbcDueReminderYesNo === 'Yes'">
          <label class="form-label">Email BBC Reminder Routine:</label>
          <select class="form-select reminder-dropdown"
                  [ngModel]="bbcSystemEmailRoutineIdReminder"
                  (change)="onChanged('BBC_SYSTEMEMAILROUTINEID_REMINDER', $event.target.value)">

            <option value="" disabled>Select email routine...</option>
            <option *ngFor="let routine of bundle.emailRoutines"
                    [value]="routine.SYSTEMEMAILROUTINEID">
              {{ routine.FOLDERNAME }}
            </option>
          </select>
        </div>

        <div class="form-row" *ngIf="bbcDueReminderYesNo === 'Yes'">
          <label class="form-label">Email BBC Past Due Routine:</label>
          <select class="form-select reminder-dropdown"
                  [ngModel]="bbcSystemEmailRoutineIdLateNotice"
                  (change)="onChanged('BBC_SYSTEMEMAILROUTINEID_LATENOTICE', $event.target.value)">

            <option value="" disabled>Select email routine...</option>
            <option *ngFor="let routine of bundle.emailRoutines"
                    [value]="routine.SYSTEMEMAILROUTINEID">
              {{ routine.FOLDERNAME }}
            </option>
          </select>
        </div>


        <div class="form-row">
          <label class="form-label">Location Page on BBC:</label>
          <div class="true-up-container"
               style="flex: 1; display: flex; align-items: center; gap: 24px; white-space: nowrap;">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeLocationYesNo"
                       [value]="'Yes'"
                       [checked]="bbcIncludeLocationYesNo === 'Yes'"
                       (change)="onChanged('BBC_INCLUDE_LOCATIONYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeLocationYesNo"
                       [value]="'No'"
                       [checked]="bbcIncludeLocationYesNo === 'No'"
                       (change)="onChanged('BBC_INCLUDE_LOCATIONYESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Payer Class Page on BBC:</label>
          <div class="true-up-container"
               style="flex: 1; display: flex; align-items: center; gap: 24px; white-space: nowrap;">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeClassYesNo"
                       [value]="'Yes'"
                       [checked]="bbcIncludeClassYesNo === 'Yes'"
                       (change)="onChanged('BBC_INCLUDE_CLASSYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeClassYesNo"
                       [value]="'No'"
                       [checked]="bbcIncludeClassYesNo === 'No'"
                       (change)="onChanged('BBC_INCLUDE_CLASSYESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Payer Plans Page on BBC:</label>
          <div class="true-up-container"
               style="flex: 1; display: flex; align-items: center; gap: 24px; white-space: nowrap;">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludePayersYesNo"
                       [value]="'Yes'"
                       [checked]="bbcIncludePayersYesNo === 'Yes'"
                       (change)="onChanged('BBC_INCLUDE_PAYERSYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludePayersYesNo"
                       [value]="'No'"
                       [checked]="bbcIncludePayersYesNo === 'No'"
                       (change)="onChanged('BBC_INCLUDE_PAYERSYESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">True-Up Page on BBC:</label>
          <div class="true-up-container"
               style="flex: 1; display: flex; align-items: center; gap: 24px; white-space: nowrap;">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeTrueUpYesNo"
                       [value]="'Yes'"
                       [checked]="bbcIncludeTrueUpYesNo === 'Yes'"
                       (change)="onChanged('BBC_INCLUDE_TRUEUPYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeTrueUpYesNo"
                       [value]="'No'"
                       [checked]="bbcIncludeTrueUpYesNo === 'No'"
                       (change)="onChanged('BBC_INCLUDE_TRUEUPYESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Unposted Page on BBC:</label>
          <div class="true-up-container"
               style="flex: 1; display: flex; align-items: center; gap: 24px; white-space: nowrap;">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeUnpostedYesNo"
                       [value]="'Yes'"
                       [checked]="bbcIncludeUnpostedYesNo === 'Yes'"
                       (change)="onChanged('BBC_INCLUDE_UNPOSTEDYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeUnpostedYesNo"
                       [value]="'No'"
                       [checked]="bbcIncludeUnpostedYesNo === 'No'"
                       (change)="onChanged('BBC_INCLUDE_UNPOSTEDYESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Census Page on BBC:</label>
          <div class="true-up-container"
               style="flex: 1; display: flex; align-items: center; gap: 24px; white-space: nowrap;">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeCensusYesNo"
                       [value]="'Yes'"
                       [checked]="bbcIncludeCensusYesNo === 'Yes'"
                       (change)="onChanged('BBC_INCLUDE_CENSUSYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeCensusYesNo"
                       [value]="'No'"
                       [checked]="bbcIncludeCensusYesNo === 'No'"
                       (change)="onChanged('BBC_INCLUDE_CENSUSYESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Unbilled Earn-In Page on BBC:</label>
          <div class="true-up-container"
               style="flex: 1; display: flex; align-items: center; gap: 24px; white-space: nowrap;">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeEarnInYesNo"
                       [value]="'Yes'"
                       [checked]="bbcIncludeEarnInYesNo === 'Yes'"
                       (change)="onChanged('BBC_INCLUDE_EARNINYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="bbcIncludeEarnInYesNo"
                       [value]="'No'"
                       [checked]="bbcIncludeEarnInYesNo === 'No'"
                       (change)="onChanged('BBC_INCLUDE_EARNINYESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

      </div>
</jqxPanel>
  </div>

  <!-- Recipient Selection Modal -->
  <div *ngIf="showRecipientModal"
       style="position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 1000;
              display: flex; align-items: center; justify-content: center;">
    <div style="background: white; border-radius: 8px; width: 90%; max-width: 600px;
                max-height: 80vh; overflow-y: auto; box-shadow: 0 4px 20px rgba(0,0,0,0.3);">

      <!-- Header -->
      <div style="padding: 16px; border-bottom: 1px solid #e0e0e0; display: flex;
                  justify-content: space-between; align-items: center; background: #f8f8f8; border-top-left-radius: 8px; border-top-right-radius: 8px;">
        <h3 style="margin: 0; font-size: 18px; color: #003399;">{{ modalTitle }}</h3>
        <button (click)="closeModal()"
                style="background: none; border: none; font-size: 28px; cursor: pointer; color: #666; line-height: 1;">
          ×
        </button>
      </div>

      <!-- Body: User list -->
      <div style="padding: 16px;">
        <div *ngIf="bundle.permittedUsers?.length === 0" style="text-align: center; color: #999; padding: 40px 0;">
          No permitted users available
        </div>

        <div *ngFor="let user of bundle.permittedUsers"
             style="display: flex; align-items: center; padding: 12px 0; border-bottom: 1px solid #f0f0f0; cursor: pointer;">
          <label style="display: flex; align-items: center; width: 100%; user-select: none;">
            <input type="checkbox"
                   [checked]="isContactSelected(user.CONTACTID)"
                   (change)="toggleContact(user.CONTACTID)"
                   style="margin-right: 16px; width: 18px; height: 18px; accent-color: #003399;" />
            <span style="flex: 1; font-size: 14px;">
              {{ user.CONTACTEMAIL || '(no email)' }}
            </span>
          </label>
        </div>
      </div>

      <!-- Footer -->
      <div style="padding: 16px; border-top: 1px solid #e0e0e0; text-align: right; background: #f8f8f8; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;">
        <button (click)="closeModal()"
                style="padding: 10px 24px; background: #003399; color: white; border: none; border-radius: 4px;
                       cursor: pointer; font-size: 14px;">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

